import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useProfileInfo } from "../../contexts/ProfileInfoContext";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import VideoPopupManager from "../VideoPopupManager";

const Layout = ({ children }) => {
    const { user } = useAuth();
    const { profileInfo } = useProfileInfo();
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    // Check if device is mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); // md breakpoint
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Set initial sidebar state based on device
    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false); // Hidden on mobile by default
        } else {
            setSidebarOpen(true); // Visible on desktop by default
        }
    }, [isMobile]);

    // Redirect to login if user is logged in but hasn't completed onboarding
    // and tries to access routes that use Layout (not onboarding routes or public landing pages)
    useEffect(() => {
        if (user) {
            const isOnboardingRoute = location.pathname.includes('/employee-profile') || 
                                     location.pathname.includes('/employer-profile') ||
                                     location.pathname.includes('/role-selection') ||
                                     location.pathname === '/login' ||
                                     location.pathname === '/signup';
            
            // Public landing pages that should be accessible without onboarding
            const isPublicLandingPage = location.pathname === '/' ||
                                       location.pathname === '/employer-landing-page' ||
                                       location.pathname === '/employee-landing-page' ||
                                       location.pathname.startsWith('/blogs') ||
                                       location.pathname === '/disclaimer' ||
                                       location.pathname === '/forgot-password' ||
                                       location.pathname === '/reset-password' ||
                                       location.pathname === '/email-verification';
            
            // If user is not on onboarding route or public landing page and profileInfo exists but onboarding is not completed, redirect to login
            if (!isOnboardingRoute && !isPublicLandingPage && profileInfo && profileInfo.onboardingcompleted !== true) {
                navigate("/login", { replace: true });
            }
        }
    }, [user, profileInfo, location.pathname, navigate]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    if (user) {
        return (
            <div className="flex h-screen bg-gray-100">
                {/* Desktop Sidebar - always visible on desktop */}
                {/* <div className="block">
                    <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} isMobile={isMobile} />
                </div> */}
                
                {/* Mobile Sidebar Overlay */}
                {/* {isMobile && sidebarOpen && (
                    <>
                        <div 
                            className="fixed inset-0 bg-black bg-opacity-50 z-40"
                            onClick={toggleSidebar}
                        />
                        <div className="fixed left-0 top-0 h-full z-50">
                            <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} isMobile={isMobile} />
                        </div>
                    </>
                )} */}
                
                <div className="flex-1 flex flex-col overflow-hidden">
                    <Navbar 
                        onToggleSidebar={toggleSidebar} 
                        sidebarOpen={sidebarOpen}
                        isMobile={isMobile}
                    />
                    <VideoPopupManager />
                    <main className="flex-1 overflow-x-hidden overflow-y-auto p-6">
                        {children}
                    </main>
                </div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );
};

export default Layout;
